import { Button, Col, Form, Input, notification, Popconfirm, Row, Select, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
import { addCityApi, listOfCityApi, listOfCountryApi, listOfStateApi, updateCityApi } from "../../../../../config/Api";
export const City = () => {
    const { Option } = Select;
    const [form] = Form.useForm();


    const [statesList, setStatesList] = useState([]);
    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [cityData, setCityData] = useState()
    const [editCityRecord, setEditCityRecord] = useState()
    const [loading, setLoading] = useState(false)

    // get the list of all available Cities 
    const getListOfCities = () => {
        setLoading(true)
        listOfCityApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }


    // get the list of all available States 
    const getListOfStates = () => {
        listOfStateApi()
            .then((res) => {
                if (res.status === 200) {
                    setStatesList(res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    const StatesOptions = [
        { id: 1, state_name: 'Gujarat', country_id: 1 },
        { id: 2, state_name: 'Maharastra', country_id: 1 },
        { id: 3, state_name: 'Rajasthan', country_id: 1 },
        { id: 4, state_name: 'Republic of Adygea', country_id: 3 },
        { id: 5, state_name: 'Altai Republic', country_id: 3 },
        { id: 6, state_name: 'Alabama', country_id: 2 },
        { id: 7, state_name: 'Alaska', country_id: 2 },
        { id: 8, state_name: 'Arizona', country_id: 2 },
        { id: 9, state_name: 'Abu Dhabi', country_id: 4 },
        { id: 10, state_name: 'Dubai', country_id: 4 }
    ]

    // call when user click on edit
    const editState = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'state': data.state_id })
        form.setFieldsValue({ 'name': data.name })
        setEditCityRecord(data);
    }

    useEffect(() => {
        getListOfCities()
        getListOfStates()
    }, []);

    // filter data according to user search input 
    useEffect(() => {
        filterCityList(cityData);
    }, [cityData]);

    // filter city list
    const filterCityList = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element?.name.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element?.state?.name.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element?.state?.country?.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };


    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Country',
            dataIndex: 'country',
            key: 'country',
            render: (text, data) => <p className="mb-0">{data?.state?.country?.name}</p>,
        },
        {
            title: 'State',
            dataIndex: 'state',
            key: 'state',
            render: (text, data) => <p className="mb-0">{data?.state?.name}</p>,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editState(record) }} className="me-2" />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'idli Rice',
            dietType: 'Cereals',
            status: true
        },
        {
            id: '2',
            name: 'Toor Dal',
            dietType: 'Protiens',
            status: false
        },
        {
            id: '3',
            name: 'Coffee',
            dietType: 'Beverages',
            status: true
        },
        {
            id: '4',
            name: 'Cabbage',
            dietType: 'Vegetables',
            status: true
        },
        {
            id: '5',
            name: 'Apple',
            dietType: 'Fruits',
            status: true
        },
    ];


    const CountryOptions = [
        { id: 1, country_name: 'India' },
        { id: 2, country_name: 'US' },
        { id: 3, country_name: 'Russia' },
        { id: 4, country_name: 'UAE' }
    ]

    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.name,
                "state_id": values.state,
            }
            addCityApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'state': '' })
                        form.setFieldsValue({ 'name': '' })
                        notification.success({
                            message: "City added successfully",
                        });
                        getListOfCities()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.name,
                "state_id": values.state,
            }
            updateCityApi(editCityRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "City Update successfully",
                        });
                        getListOfCities()
                        form.setFieldsValue({ 'state': '' })
                        form.setFieldsValue({ 'name': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };
    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="RoutineDiet">
            <Row>
                <Col xl={18}>
                    <Form
                        name="AddRoutineDietForm"
                        className="AddRoutineDietForm"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row>
                            <Col xl={7} className="ms-1">
                                <Form.Item
                                    name="state"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select State!",
                                        },
                                    ]}
                                    initialValue=""
                                >
                                    <Select
                                        // value={regType}
                                        showSearch
                                        filterOption={(inputValue, option) =>
                                            option?.children?.toLowerCase().includes(inputValue?.toLowerCase())
                                        }
                                    >
                                        <Option value="" disabled hidden>
                                            Select State
                                        </Option>
                                        {
                                            statesList && statesList.length > 0 && statesList.map((option) =>
                                                <Option value={option.id}>{option.name}</Option>
                                            )
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xl={7} className="ms-1">
                                <Form.Item
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter City Name!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter City Name" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={2}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2"
                                    icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}>
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={2} className="text-end align-self-center">
                    {/* <h6>{tagCategory ?  `Total ${tagCategory}` : "Total Tags"  }</h6> */}
                    <h6> Total : {displayData.length > 0 ? displayData.length : 0}   </h6>
                </Col>
                <Col xl={4} className="align-self-center">
                    <Input.Search placeholder="Search City"
                        onChange={(e) => { filterCityList(e.target.value); setCityData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
